import React from "react";
import { AiOutlineClose } from "react-icons/ai";

const MailPopup = ({ isOpen, onClose, subject, body, purpose, date }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg w-[90%] max-w-2xl mx-4 md:mx-auto relative max-h-[90vh] shadow-lg">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
        >
          <AiOutlineClose className="text-xl" />
        </button>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[90vh]">
          <div className="mb-6">
            <h3 className="text-primary text-sm md:text-base font-medium mb-2">
              Subject
            </h3>
            <h2 className="text-gray-800 text-xl md:text-2xl font-semibold">
              {subject}
            </h2>
          </div>

          <div className="mb-6">
            <h3 className="text-primary text-sm md:text-base font-medium mb-2">
              Purpose
            </h3>
            <p className="text-gray-600 text-sm md:text-base">{purpose}</p>
          </div>

          <div className="mb-6">
            <h3 className="text-primary text-sm md:text-base font-medium mb-2">
              Date
            </h3>
            <p className="text-gray-600 text-sm md:text-base">{date}</p>
          </div>

          <div>
            <h3 className="text-primary text-sm md:text-base font-medium mb-2">
              Message
            </h3>
            <div className="bg-gray-50 rounded-lg p-4 max-h-[40vh] overflow-y-auto custom-scrollbar border border-gray-200">
              <p className="text-gray-700 text-sm md:text-base whitespace-pre-wrap">
                {body}
              </p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
        .custom-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default MailPopup;
